import Requests from './requests'

export default class Schemas extends Requests {

  list (page = 1, query = '', sort = '', perPage = 0, count = false) {
    return this._getMany(page, query, sort, perPage, count)
  }

  get (id) {
    return this._getOne(id)
  }

  create (schema) {
    return this._create(schema)
  }

  update (schema) {
    return this._update(schema)
  }

  delete (id) {
    return this._delete(id)
  }

}



// WEBPACK FOOTER //
// ./src/schemas.js